import React from "react";
import { styled } from "@mui/system";
import MUIRadio, { RadioProps } from "@mui/material/Radio";

export const Radio = styled((props: RadioProps) => <MUIRadio {...props} />, {
  name: "Radio",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiRadio-root	": {
    color: theme.palette.primary.primary,
    "&:hover": {
      background: "transparent",
    },
  },
  "&.MuiRadio-root.Mui-checked .MuiSvgIcon-root": {
    color: theme.palette.primary.blueColor,
  },
  "&.MuiRadio-root.Mui-disabled .MuiSvgIcon-root": {
    color: theme.palette.primary.textDisabledColor,
  },
  "&.MuiRadio-root.Mui-checked.Mui-disabled .MuiSvgIcon-root": {
    color: theme.palette.primary.textDisabledColor,
  },
}));
